export const AVATAR_STATUS = {
    online: 'online',
    offline: 'offline',
    busy: 'busy',
    away: 'away',
} as const

export const AVATAR_STATUS_ARRAY = Object.values(AVATAR_STATUS)
